import { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import axios from 'axios';
import { formatDate } from '../utils/dateFormat';

/** What iBigDo decided about each material this organization asked for, for its Org Admin, until dismissed. */
export function describeUpdate(u) {
  const changed = u.categoryAfter && u.categoryBefore && u.categoryAfter !== u.categoryBefore;
  const where = changed ? ` We moved it to the category "${u.categoryAfter}".` : '';
  const hs = u.hsCodeAfter && u.hsCodeAfter !== u.hsCodeBefore ? ` Its HSN is now ${u.hsCodeAfter}.` : '';
  switch (u.decision) {
    case 'MERGED':
      return `"${u.itemName}" was the same as the shared material "${u.resultItemName}", so we joined them. Everything you recorded against it now shows "${u.resultItemName}".${hs}`;
    case 'LINKED':
      return `"${u.itemName}" was approved and filed under "${u.resultItemName}". It stays its own material, private to you, with its own stock and cost.${where}${hs}`;
    case 'MADE_GLOBAL':
      return `"${u.itemName}" is now in the shared Global Material Master, so every organization can use it. Nothing changes for you.${where}${hs}`;
    case 'REMOVED':
      return `"${u.itemName}" was removed from your requests. If you still need it, add it again or ask Help & Support.`;
    default:
      return `"${u.itemName}" was reviewed and approved. It stays private to you.${where}${hs}`;
  }
}

function MaterialRequestUpdates() {
  const [updates, setUpdates] = useState([]);

  const load = () => axios.get('/api/organization-materials/request-updates')
    .then((r) => setUpdates(Array.isArray(r.data) ? r.data : []))
    .catch(() => setUpdates([]));

  useEffect(() => { load(); }, []);

  const dismiss = async (id) => {
    setUpdates((list) => list.filter((u) => u.id !== id));
    try { await axios.post(`/api/organization-materials/request-updates/${id}/dismiss`); } catch (e) { load(); }
  };
  const dismissAll = async () => {
    setUpdates([]);
    try { await axios.post('/api/organization-materials/request-updates/dismiss-all'); } catch (e) { load(); }
  };

  if (updates.length === 0) return null;
  return (
    <Alert variant="info" className="mt-3" data-testid="material-request-updates">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong>About the materials you asked for</strong>
        {updates.length > 1 && <Button size="sm" variant="outline-secondary" onClick={dismissAll}>Dismiss all</Button>}
      </div>
      {updates.map((u) => (
        <div key={u.id} className="d-flex justify-content-between align-items-start gap-2 py-1">
          <div>
            {describeUpdate(u)} <span className="text-muted small">{formatDate(u.decidedAt)}</span>
          </div>
          <Button size="sm" variant="link" className="p-0 text-nowrap" onClick={() => dismiss(u.id)}>Dismiss</Button>
        </div>
      ))}
    </Alert>
  );
}

export default MaterialRequestUpdates;
